module.exports = __webpack_public_path__ + "img/img10.4a86d930.svg";